import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import Layout from './components/Layout';
import Home from './pages/Home';
import OurJourney from './pages/OurJourney';
import OurTeam from './pages/OurTeam';
import Resources from './pages/Resources';
import ContactUs from './pages/ContactUs';
import Apply from './pages/Apply';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' }); // jump to top immediately
  }, [pathname]);

  return null;
}

function AnimatedRoutes() {
  const location = useLocation();

  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <Home />
            </motion.div>
          }
        />
        <Route
          path="/our-journey"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <OurJourney />
            </motion.div>
          }
        />
        <Route
          path="/our-team"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <OurTeam />
            </motion.div>
          }
        />
        <Route
          path="/resources"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <Resources />
            </motion.div>
          }
        />
        <Route
          path="/contact-us"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <ContactUs />
            </motion.div>
          }
        />
        <Route
          path="/apply"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <Apply />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

// function TopBanner() {
//   return (
//     <a 
//       href="https://drive.google.com/file/d/1SCKXIxXYobCqe1YUjiUF4Uq3cG_UVHzI/view?usp=sharing" 
//       className="top-banner"
//       style={{ textDecoration: "none", color: "inherit" }}
//     >
//       📢 Click to read our November Newsletter!
//     </a>
//   );
// }



export default function App() {
  return (
    <Router>
      <ScrollToTop /> {/* This ensures we scroll up on every route change */}
      {/* <TopBanner /> */}
      <Layout>
        <AnimatedRoutes />
      </Layout>
    </Router>
  );
}
